import {
  answerQuestionDetails,
  LogOutActionTypes,
  GET_PATIENT_TEAM_FAIL,
  GET_PATIENT_TEAM_LOADING,
  GET_PATIENT_TEAM_SUCCESS,
} from "./ActionTypes";
import { GetPatientTeamResponse } from "./Model";

const initialStateGetPosts: answerQuestionDetails = {
  loading: false,
  getPatientTeamRes: {} as GetPatientTeamResponse,
  errRes: "",
};
export const getPatientTeamReducer = (
  state = initialStateGetPosts,
  action: LogOutActionTypes
): answerQuestionDetails => {
  switch (action.type) {
    case GET_PATIENT_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        getPatientTeamRes: action.payload,
        errRes: "",
      };
    case GET_PATIENT_TEAM_LOADING:
      return {
        ...state,
        loading: true,
        getPatientTeamRes: {} as GetPatientTeamResponse,
      };
    case GET_PATIENT_TEAM_FAIL:
      return {
        ...state,
        getPatientTeamRes: {} as GetPatientTeamResponse,
        loading: false,
        errRes: action.errRes,
      };
    default:
      return state;
  }
};
